import Dropdown from "./Dropdown";
import DropdownItem from "./DropdownItem";
import DropdownMenu from "./DropdownMenu";

Dropdown.Item = DropdownItem;
Dropdown.Menu = DropdownMenu;

export default Dropdown;
